module.exports = __webpack_public_path__ + "static/media/loading2.b4e67bf4.svg";